import { Mail } from "@ellaandil/ui";
import type { BlokProps } from "@trydig/storyblok";
import { clsx } from "@trydig/ui";
import { BlokWrap } from "@/components/bloks/BlokWrap";
import { Asset } from "@/components/ui/Asset";
import { Link } from "@/components/ui/Link";
import { Typography } from "@/components/ui/Typography";
import type { EmployeeStoryblok } from "@/generated/sb/sb-types";

export const EmployeeBlok = ({
	blok,
	darkMode,
}: BlokProps<EmployeeStoryblok> & { darkMode?: boolean }) => {
	return (
		<BlokWrap
			editable={blok}
			className="flex items-center gap-grid-component-spacing-md tetx-red-500"
		>
			<div className="relative size-[120px] shrink-0 overflow-hidden">
				<Asset asset={blok.image} sizes="120px" className="object-cover" />
			</div>
			<div className="flex min-w-px flex-1 flex-col gap-grid-component-spacing-md">
				{(blok.jobTitle || blok.name) && (
					<div
						className={clsx(
							"flex flex-col gap-grid-component-spacing-2xs text-text-dark-text-1",
							darkMode && "text-text-light-text-1",
						)}
					>
						{blok.jobTitle && (
							<Typography variant="label-sm-reg" as="p">
								{blok.jobTitle}
							</Typography>
						)}
						{blok.name && (
							<Typography variant="heading-md" as="p" className="leading-[1.25]">
								{blok.name}
							</Typography>
						)}
					</div>
				)}
				{blok.email && (
					<div className="flex flex-col gap-grid-component-spacing-2xs">
						<Link
							className={clsx(darkMode && "text-text-light-text-1")}
							href={`mailto:${blok.email}`}
							variant="primary"
							size="medium"
							leftIcon={Mail}
						>
							{blok.email}
						</Link>
					</div>
				)}
			</div>
		</BlokWrap>
	);
};
